module.exports = __webpack_public_path__ + "static/media/illo-gift.d37c0a25.png";